<template>
  <div class="app-wrapper">
    <router-view />
    <toast
      :show="showToast"
      :type="toastType"
      :message="toastMessage"
      @close="toggleToast(false)"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, watch } from 'vue';
import Toast from '@/components/Toast.vue';
import { useTaxonomy, useAuth, useToast } from '@/hooks';

export default defineComponent({
  name: 'App',
  components: {
    Toast,
  },
  setup() {
    const { isAuthenticated } = useAuth();
    const { getTaxonomy } = useTaxonomy();
    const { show: showToast, type: toastType, message: toastMessage, toggleToast } = useToast();

    watch(
      () => isAuthenticated.value,
      () => {
        if (isAuthenticated.value) {
          // get any essential data when app initially loaded
          getTaxonomy();
        }
      }
    );

    return {
      showToast,
      toastType,
      toastMessage,
      toggleToast,
    };
  },
});
</script>

<style lang="scss">
.app-wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}
</style>
